module.exports = __webpack_public_path__ + "img/4life-Cer-Default.cb81e513.jpg";